module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-158.64d3e17e.svg";